import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Col } from 'antd';
import { SPAN_FULL } from '../../../../../../../styles/constants';
import { onChangeIfFunction } from '../../actions';
import FormList from '../../../../../../../components/form-list';
import _ from "lodash";
import IffBlock from './IffBlock';
import { getInitialIIFBlock } from '../../../utils';
import functionsData from '../../../../../../../config/functions.json';
import operatorsData from '../../../../../../../config/operators.json';

const mapStateToProps = state => ({
  IfFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.IfFormData,
  IfFormDataList:state.scenes.dataManager.fileMapping.components.wizard.components.addField.IfFormDataList,
  mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
});

const mapDispatchToProps = dispatch => ({
    onChangeForm: value => dispatch(onChangeIfFunction(value)),
});

const FileMappingWizardIIFWizard = ({
                                      t,
                                      onChangeForm,
                                      IfFormDataList,
                                      mergedHeader
                                    }) => {
    
  const selectFunction = React.useMemo(()=> {
      const FunctionsDta = functionsData.Functions.filter(e => e.Name !== 'Concat' && e.Name !== 'Case' && e.Name !== 'File' && e.Name !== 'IIF' && e.Name)
      .map(e => e.Name)
      return _.concat(['Str func'], FunctionsDta)
  },[functionsData])



  const selectComponent = React.useMemo(()=>{
    return  _.some(mergedHeader) ? mergedHeader.map(e => e.name) : []
  },[mergedHeader])

 

  const selectOperators = React.useMemo(()=>{
    return operatorsData.Operators.map(e => !['AND', 'OR', '()'].includes(e.label) && e.label).filter(Boolean)
  },[operatorsData]) 

  const blockIndex = (IfFormDataList || []).length

  return (
        <Col span={SPAN_FULL}>
        <FormList
          notCollapsable
          values={IfFormDataList}
          Component={IffBlock}
          newItem={getInitialIIFBlock(blockIndex)}
          onChange={(values) => onChangeForm({blocks:values})}
          componentProps={{
            selectFunction,
            selectComponent,
            selectOperators
          }}
          addItemLabel={t('scenes.dataManager.fileMapping.wizard.addField.functions.iif.label.addBlock')}
          removeItemLabel={t('scenes.dataManager.fileMapping.wizard.addField.functions.iif.label.removeBlock')}
        />
        </Col>
);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(FileMappingWizardIIFWizard);